export default "__VITE_ASSET__CZtMJhGM__"